// Même calcul que _price_request_fare côté serveur (le serveur reste la référence).
export function requestFare(pricing, km, scheduledAt) {
  const base = Number(pricing.base_eur), perKm = Number(pricing.per_km_eur);
  const instant = base + perKm * km;
  let price = instant;
  let tier = "instant";
  if (scheduledAt) {
    const short = instant * (100 - Number(pricing.scheduled_discount_pct ?? 20)) / 100;
    const leadH = (new Date(scheduledAt).getTime() - Date.now()) / 3600e3;
    if (leadH >= Number(pricing.scheduled_degressive_lead_hours ?? 5)) {
      const cut = Number(pricing.degressive_from_km ?? 80);
      const degressive = base + Math.min(km, cut) * perKm + Math.max(km - cut, 0) * Number(pricing.degressive_per_km_eur ?? 0.11);
      price = Math.min(degressive, short);
      tier = "scheduled_long_lead";
    } else {
      price = short;
      tier = "scheduled_short_lead";
    }
  }
  price = Math.max(Number(pricing.min_fare_eur || 0), price);
  return { price, instant, tier };
}

export function fareTierLabel(pricing, tier) {
  if (tier === "scheduled_short_lead") return `Course programmée : -${Number(pricing.scheduled_discount_pct ?? 20)} % sur le tarif immédiat`;
  if (tier === "scheduled_long_lead") return `Réservée ${Number(pricing.scheduled_degressive_lead_hours ?? 5)} h à l'avance ou plus : tarif dégressif après ${Number(pricing.degressive_from_km ?? 80)} km`;
  return "";
}
